import React from 'react';
import CompanyList from './CompanyList';

const Companies = () => {
  return <CompanyList />;
};

export default Companies;
